import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDocumentType, PmsDocumentType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDocumentType>
    useData={usePmsDocumentType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
